import { app } from '../../../../../app';
import { Controller } from './dropbox-provisioning-settings.controller';

app.component('dropboxProvisioningSettings', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./dropbox-provisioning-settings.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/dropbox-provisioning/dropbox-provisioning-settings/dropbox-provisioning-settings.component.js